/**
 * bootprompt.js locale configuration
 * locale : Hebrew
 * author : Chen Alon
 */

import { addLocale } from "../bootprompt";

addLocale("he", {
  OK: "אישור",
  CANCEL: "ביטול",
  CONFIRM: "אישור",
});
